module.exports = __webpack_public_path__ + "static/media/electronics3.37eaaa04.jpg";